import React from "react";
import LineOrange from "../../../common/LineOrange/LineOrange";
export const InfoApp = () => {
  return (
    <>
      <div className="text-center mb-5">
        <p style={{ fontSize: "28px", fontWeight: "800" }}>همراه‌تریدر</p>
        <h3>اپلیکیشنی کامل جهت مدیریت سهام شما</h3>
        <LineOrange />
      </div>
    </>
  );
};
